import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M3.568 3.405c2.753 2.232 5.386 4.162 6.245 7.59.484 1.897-.641 3.19-1.61 3.525-1.817.67-3.997 0-3.997-2.342.922-5.048 13.612-3.56 14.503-2.739.121.67.121.106 0 .776 0 .223-.12.557-.12.78 0 .893.363 1.674.847 2.343 1.09 1.115.121 1.673-.848 2.342l-.363 1.785c-.242 1.116-1.333 1.896-2.423 1.896h-1.695s-.727.67-.606 2.231"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M6.391 2.873H3v3.123"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M17.552 2.879H20v2.567M20 2.879l-3.408 3.323"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const AdhdIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
